import * as React from 'react';
import styled, { css } from '../../../styled/index';
import { Modal } from '../../layout/modal/index';
import { ModalContent } from '../../layout/modal/content';
import { shadeAlternate } from '../../../styled/helpers';
import { Input } from '../input/index';
import { RotateLoader } from '../../loaders/rotate/index';
// import autobind from "autobind-decorator";
import { logger } from '@lib/common';
const SelectWrapper = styled('div') `
  height: 100%;
  max-height: 300px;
  overflow-y: auto;
  ${({ roundBottom }) => !roundBottom
    ? ''
    : css `
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
        `}
`;
const SelectItem = styled('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => shadeAlternate(0.1, theme.box.background)};
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.05, theme.box.background)};
  }
  ${({ disabled, theme }) => !disabled
    ? ''
    : css `
          cursor: not-allowed;
          background: ${shadeAlternate(0.1, theme.box.background)};
        `};
  p {
    font-size: 14px;
    line-height: 1.4;
  }
`;
export class SearchModal extends React.Component {
    searched = false;
    timer;
    constructor(props) {
        super(props);
        this.state = {
            values: [],
            search: '',
            loading: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.active && this.props.active) {
            setTimeout(() => {
                const list = document.getElementById(this.props.innerId);
                const input = document.getElementById(this.props.innerId + '-input');
                if (list) {
                    list.scrollTop = 0;
                    list.scroll({ top: 0, left: 0, behavior: 'auto' });
                }
                if (input) {
                    input.focus();
                }
            }, 50);
        }
        if (this.state.search && prevState.search !== this.state.search) {
            this.setState({ loading: true });
            clearTimeout(this.timer);
            this.timer = setTimeout(this.handleSearch, 500);
        }
    }
    searchInputChange = (e) => {
        this.setState({
            search: e.target.value,
        });
    };
    handleSearch = async () => {
        this.searched = true;
        let values = [];
        try {
            values = await this.props.handleSearch(this.state.search);
        }
        catch (e) {
            if (e !== 'Nothing found' && e && e.message !== 'Not Found') {
                // IGNORE AUTOCOMPLETE GOOGLE ERRORS
                logger.captureException(e);
            }
        }
        finally {
            this.setState({
                values: values,
                loading: false,
            });
        }
    };
    render() {
        const { innerId, handleSelect, attribution, translationFunction: t } = this.props;
        const { values, search, loading } = this.state;
        return (React.createElement(Modal, { closeButton: true, ...this.props },
            React.createElement(ModalContent, { className: "text-center no-border-bottom" },
                React.createElement("p", { className: "big" }, t('store.modals.order.config.address.search_placeholder'))),
            React.createElement(ModalContent, { paddinglr: 0, paddingtb: 0, className: "no-border-bottom" },
                React.createElement(Input, { id: `${innerId}-input`, className: !attribution && !loading && values.length === 0
                        ? 'no-round-top round-bottom no-border-lr'
                        : 'no-round no-border-lr', placeholder: `${t('store.modals.order.config.address.search_input_placeholder')}`, value: search, onChange: this.searchInputChange })),
            loading && (React.createElement(ModalContent, { paddinglr: 10, paddingtb: 10, className: attribution ? '' : 'round-bottom' },
                React.createElement(RotateLoader, { size: 2 }))),
            !loading && values.length > 0 && (React.createElement(ModalContent, { paddinglr: 0, paddingtb: 0 },
                React.createElement(SelectWrapper, { id: innerId, roundBottom: !attribution }, values.map((o, i) => {
                    return (React.createElement(SelectItem, { key: i, onClick: () => handleSelect(o) },
                        React.createElement("p", null, o.label)));
                })))),
            !loading && this.searched && values.length === 0 && (React.createElement(ModalContent, { paddinglr: 0, paddingtb: 0 },
                React.createElement(SelectWrapper, { id: innerId, roundBottom: !attribution },
                    React.createElement(SelectItem, { className: "text-center" },
                        React.createElement("p", null, t('store.modals.order.config.address.no_address_found')))))),
            !!attribution && attribution));
    }
}
//# sourceMappingURL=index.js.map